// -- MESSAGES
const _MESSAGES = {
  required: "* Campo obrigatório",
  invalidEmail: "* E-mail inválido",
  invalidPassword:
    "* A password deve conter no minimo 8 carateres (maiúscula, minúscula, alfanumérico, simbolo)",
  invalidNumber: "* O valor inserido deve ser numérico"
}

// -- RULES
const _RULES = {
  required: v => !!v || _MESSAGES.required,
  email: v =>
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
      v
    ) || _MESSAGES.invalidEmail,
  isNumber: v => !!Number.isInteger(Number(v)) || _MESSAGES.invalidNumber,
  isFloat: v => !!!Number.isNaN(parseFloat(v)) || _MESSAGES.invalidNumber
}

export { _RULES, _MESSAGES }
